import React from "react";
import clsx from "clsx";

export type MedalIconNumerator = 1 | 2 | 3 | 4 | 5;

type MedalIconProps = {
  iconRange?: MedalIconNumerator;
  className?: string;
  style?: React.CSSProperties;
};

const MedalIcon: React.FunctionComponent<MedalIconProps> = ({
  iconRange,
  className,
  style,
}) => {
  let iconSvg;

  switch (iconRange) {
    case 1:
      iconSvg = (
        <svg
          version="1.2"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          overflow="visible"
          preserveAspectRatio="none"
          viewBox="0 0 362 362"
          xmlSpace="preserve"
          y="0px"
          x="0px"
          id="Layer_1_1568801036991"
        >
          <g transform="translate(1, 1)">
            <path
              d="M313.55,135.66l-18.02,30.49v35.34l-30.49,18.01L247.72,250h-4.85v96.32c0,2.77-0.69,4.85-2.08,6.24  c-1.85,1.85-3.93,2.77-6.24,2.77c-3.24,0-5.54-1.15-6.93-3.47l-45.73-45.73l-46.43,45.73c-1.39,2.32-3.47,3.47-6.24,3.47h-0.69  c-2.32,0-4.16-0.92-5.55-2.77c-1.85-1.39-2.77-3.47-2.77-6.24V250h-4.16l-18.01-30.5l-30.49-18.01v-35.34l-18.02-30.49l18.02-30.49  V69.83l30.49-18.02l18.02-30.49h35.34L181.89,4l30.49,17.32h35.34l17.32,30.49l31.18,18.02v35.34L313.55,135.66z M293.45,135.66  l-15.24-25.64v-29.8l-25.64-15.25l-15.24-25.64h-29.8L181.89,24.1l-26.33,15.24h-29.8l-14.55,25.64L84.87,80.22v29.8l-14.55,25.64  l14.55,25.64v30.49l26.33,14.55l14.55,25.64h29.8l26.33,15.25l25.64-15.25h29.8l15.24-25.64l25.64-14.55V161.3L293.45,135.66z   M225.54,250h-13.17l-30.49,17.32L151.4,250h-13.86v75.53l36.73-36.73l1.39-1.38c1.39-1.39,3.46-2.08,6.23-2.08  c2.31,0,4.39,0.69,6.24,2.08v0.69l0.69,0.69l36.73,36.73v-49.89L225.54,250L225.54,250z M197.82,197.33V73.98h-20.1  c-0.46,4.16-1.85,8.09-4.16,11.78c-1.85,2.32-4.62,4.85-8.31,7.63c-3.7,2.31-7.39,3.7-11.09,4.15c-2.77,0.46-6.93,0.69-12.48,0.69  v18.71h31.19v80.38L197.82,197.33L197.82,197.33z"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </svg>
      );
      break;

    case 2:
      iconSvg = (
        <svg
          version="1.2"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          overflow="visible"
          preserveAspectRatio="none"
          viewBox="0 0 362 362"
          xmlSpace="preserve"
          y="0px"
          x="0px"
          id="Layer_1_1568801036989"
        >
          <g transform="translate(1, 1)">
            <path
              d="M311.55,135.66l-18.02,30.49v35.34l-30.49,18.01L245.72,250h-4.85v96.32c0,2.77-0.69,4.85-2.08,6.24  c-1.85,1.85-3.93,2.77-6.24,2.77c-3.24,0-5.54-1.15-6.93-3.47l-45.73-45.73l-46.43,45.73c-1.39,2.32-3.47,3.47-6.24,3.47h-0.69  c-2.32,0-4.16-0.92-5.55-2.77c-1.85-1.39-2.77-3.47-2.77-6.24V250h-4.16l-18.01-30.5l-30.49-18.01v-35.34l-18.02-30.49l18.02-30.49  V69.83l30.49-18.02l18.02-30.49h35.34L179.89,4l30.49,17.32h35.34l17.32,30.49l31.18,18.02v35.34L311.55,135.66z M291.45,135.66  l-15.24-25.64v-29.8l-25.64-15.25l-15.24-25.64h-29.8L179.89,24.1l-26.33,15.24h-29.8l-14.55,25.64L82.87,80.22v29.8l-14.55,25.64  l14.55,25.64v30.49l26.33,14.55l14.55,25.64h29.8l26.33,15.25l25.64-15.25h29.8l15.24-25.64l25.64-14.55V161.3L291.45,135.66z   M134.85,121.11h24.25c0-4.61,0.23-8.08,0.69-10.4c0.46-2.3,1.62-5.3,3.47-9c1.39-2.31,3.46-4.61,6.24-6.93  c3.69-1.84,6.69-2.77,9.01-2.77c5.54,0,10.16,1.85,13.86,5.54c3.22,3.24,4.85,7.86,4.85,13.86c0,3.24-0.69,6.7-2.08,10.4  c-2.77,3.7-5.09,6.23-6.93,7.62c-1.85,2.32-4.62,4.63-8.31,6.93c-1.85,0.93-4.62,2.77-8.31,5.54c-5.54,3.7-10.63,7.39-15.24,11.09  c-5.54,3.7-9.7,7.39-12.48,11.09c-3.24,4.15-6.01,9.01-8.31,14.55c-2.32,6.01-3.46,12.25-3.46,18.71h91.47v-21.48h-58.9  c3.23-5.08,6.69-8.77,10.4-11.09c2.77-2.31,6.93-5.31,12.47-9.01l12.47-8.31c4.61-3.7,8.54-6.93,11.78-9.7  c2.31-2.31,4.85-6.24,7.62-11.78c2.31-5.54,3.46-11.09,3.46-16.63c0-5.08-1.16-10.39-3.46-15.94c-3.24-5.55-6.48-9.7-9.7-12.48  c-2.32-2.31-6.7-4.85-13.16-7.62c-5.09-1.84-10.63-2.77-16.63-2.77c-7.39,0-13.86,1.38-19.4,4.15c-5.54,1.85-10.4,5.31-14.55,10.39  c-4.62,6.48-7.39,11.78-8.31,15.94C135.77,106.56,134.85,113.26,134.85,121.11z M223.54,250h-13.17l-30.49,17.32L149.4,250h-13.86  v75.53l36.73-36.73l1.39-1.38c1.39-1.39,3.46-2.08,6.23-2.08c2.31,0,4.39,0.69,6.24,2.08v0.69l0.69,0.69l36.73,36.73v-49.89  L223.54,250L223.54,250z"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </svg>
      );
      break;

    case 3:
      iconSvg = (
        <svg
          version="1.2"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          overflow="visible"
          preserveAspectRatio="none"
          viewBox="0 0 362 362"
          xmlSpace="preserve"
          y="0px"
          x="0px"
          id="Layer_1_1568801036988"
        >
          <g transform="translate(1, 1)">
            <path
              d="M309.55,135.66l-18.02,30.49v35.34l-30.49,18.01L243.72,250h-4.85v96.32c0,2.77-0.69,4.85-2.08,6.24  c-1.85,1.85-3.93,2.77-6.24,2.77c-3.24,0-5.54-1.15-6.93-3.47l-45.73-45.73l-46.43,45.73c-1.39,2.32-3.47,3.47-6.24,3.47h-0.69  c-2.32,0-4.16-0.92-5.55-2.77c-1.85-1.39-2.77-3.47-2.77-6.24V250h-4.16l-18.01-30.5l-30.49-18.01v-35.34l-18.02-30.49l18.02-30.49  V69.83l30.49-18.02l18.02-30.49h35.34L177.89,4l30.49,17.32h35.34l17.32,30.49l31.18,18.02v35.34L309.55,135.66z M289.45,135.66  l-15.24-25.64v-29.8l-25.64-15.25l-15.24-25.64h-29.8L177.89,24.1l-26.33,15.24h-29.8l-14.55,25.64L80.87,80.22v29.8l-14.55,25.64  l14.55,25.64v30.49l26.33,14.55l14.55,25.64h29.8l26.33,15.25l25.64-15.25h29.8l15.24-25.64l25.64-14.55V161.3L289.45,135.66z   M168.88,123.19v18.02h9.7c3.22,0,6.23,0.69,9.01,2.08c3.69,1.85,6,3.7,6.93,5.54c1.84,1.85,2.77,5.32,2.77,10.4  c0,6.01-1.85,10.86-5.54,14.55c-4.63,3.71-9.47,5.54-14.55,5.54c-3.7,0-6.93-0.69-9.7-2.08c-2.77-1.38-4.85-3.22-6.24-5.54  c-1.85-1.84-3.24-4.38-4.16-7.62c0-0.45-0.69-3.7-2.08-9.7h-23.56c0,7.86,0.92,14.32,2.77,19.4c3.22,6.48,6.46,11.09,9.7,13.86  c3.69,3.7,8.54,6.7,14.55,9c5.08,1.85,11.31,2.77,18.71,2.77c6.93,0,12.93-0.92,18.02-2.77c5.08-1.38,9.93-3.92,14.55-7.62  c4.16-3.69,7.62-7.85,10.4-12.48c2.31-6,3.46-11.77,3.46-17.32c0-6.47-1.85-12.7-5.54-18.71c-4.62-5.08-10.17-8.31-16.63-9.7v-0.69  c6-1.39,10.4-4.39,13.17-9.01c2.77-4.61,4.16-9.93,4.16-15.94c0-6.46-1.16-11.31-3.47-14.55c-2.77-5.07-6.01-8.77-9.7-11.09  c-3.7-2.31-8.09-4.61-13.17-6.93c-4.62-1.39-9.7-2.08-15.24-2.08c-5.54,0-11.32,1.15-17.32,3.46c-5.54,2.32-9.94,5.09-13.17,8.31  c-4.16,4.16-7.17,8.79-9.01,13.86c-1.39,3.7-2.54,9.47-3.46,17.32h24.25c0-6.93,1.61-12.24,4.85-15.94  c2.77-4.15,7.38-6.24,13.86-6.24c4.61,0,8.77,1.39,12.47,4.16c3.69,2.77,5.54,6.93,5.54,12.47c0,3.71-0.93,6.48-2.77,8.32  c-1.39,2.31-3.46,3.92-6.24,4.85c-2.77,1.38-5.78,2.08-9.01,2.08C174.42,123.65,171.65,123.65,168.88,123.19z M221.54,250h-13.17  l-30.49,17.32L147.4,250h-13.86v75.53l36.73-36.73l1.39-1.38c1.39-1.39,3.46-2.08,6.23-2.08c2.31,0,4.39,0.69,6.24,2.08v0.69  l0.69,0.69l36.73,36.73v-49.89L221.54,250L221.54,250z"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </svg>
      );
      break;

    case 4:
      iconSvg = (
        <svg
          version="1.2"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          overflow="visible"
          preserveAspectRatio="none"
          viewBox="0 0 362 362"
          xmlSpace="preserve"
          y="0px"
          x="0px"
          id="Layer_1_1568801036988"
        >
          <g transform="translate(1, 1)">
            <path
              d="M311.55,135.66l-18.02,30.49v35.34l-30.49,18.01L245.72,250h-4.85v96.32c0,2.77-0.69,4.85-2.08,6.24  c-1.85,1.85-3.93,2.77-6.24,2.77c-3.24,0-5.54-1.15-6.93-3.47l-45.73-45.73l-46.42,45.73c-1.39,2.32-3.47,3.47-6.24,3.47h-0.69  c-2.32,0-4.16-0.92-5.54-2.77c-1.85-1.39-2.78-3.47-2.78-6.24V250h-4.15l-18.03-30.5l-30.49-18.01v-35.34l-18.02-30.49l18.02-30.49  V69.83l30.49-18.02l18.02-30.49h35.34L179.89,4l30.49,17.32h35.34l17.32,30.49l31.18,18.02v35.34L311.55,135.66z M291.45,135.66  l-15.25-25.64v-29.8l-25.64-15.25l-15.24-25.64h-29.8L179.89,24.1l-26.33,15.24h-29.8l-14.55,25.64L82.87,80.22v29.8l-14.55,25.64  l14.55,25.64v30.49l26.33,14.55l14.55,25.64h29.8l26.33,15.25l25.64-15.25h29.8l15.24-25.64l25.64-14.55V161.3L291.45,135.66z   M184.73,170.31v28.41h23.56v-28.41h16.63v-20.79H208.3V74.68h-22.17l-54.05,72.07v23.56H184.73z M223.54,250h-13.17l-30.49,17.32  L149.4,250h-13.86v75.53l36.73-36.73l1.38-1.38c1.39-1.39,3.47-2.08,6.24-2.08c2.31,0,4.38,0.69,6.24,2.08v0.69l0.69,0.69  l36.73,36.73v-49.89V250H223.54z M184.73,106.56v42.96h-32.56l31.88-42.96C184.05,106.56,184.73,106.56,184.73,106.56z"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </svg>
      );
      break;

    case 5:
      iconSvg = (
        <svg
          version="1.2"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          overflow="visible"
          preserveAspectRatio="none"
          viewBox="0 0 362 362"
          xmlSpace="preserve"
          y="0px"
          x="0px"
          id="Layer_1_1568801036990"
        >
          <g transform="translate(1, 1)">
            <path
              d="M307.55,135.66l-18.02,30.49v35.34l-30.49,18.01L241.72,250h-4.85v96.32c0,2.77-0.69,4.85-2.08,6.24  c-1.85,1.85-3.93,2.77-6.24,2.77c-3.24,0-5.54-1.15-6.93-3.47l-45.73-45.73l-46.43,45.73c-1.38,2.32-3.46,3.47-6.23,3.47h-0.69  c-2.32,0-4.16-0.92-5.54-2.77c-1.85-1.39-2.77-3.47-2.77-6.24V250h-4.16L92.04,219.5l-30.49-18.01v-35.34l-18.02-30.49l18.02-30.49  V69.83l30.49-18.02l18.02-30.49h35.34L175.89,4l30.49,17.32h35.34l17.32,30.49l31.18,18.02v35.34L307.55,135.66z M287.45,135.66  l-15.25-25.64v-29.8l-25.64-15.25l-15.24-25.64h-29.8L175.89,24.1l-26.33,15.24h-29.79l-14.55,25.64L78.88,80.22v29.8l-14.55,25.64  l14.55,25.64v30.49l26.33,14.55l14.55,25.64h29.79l26.33,15.25l25.64-15.25h29.8l15.24-25.64l25.64-14.55V161.3L287.45,135.66z   M214,94.08V73.3h-69.3l-11.78,68.6h22.87c2.31-3.7,4.85-6.24,7.62-7.63c2.78-1.38,6.47-2.08,11.09-2.08c4.15,0,7.16,0.46,9,1.38  c2.78,1.39,5.08,3.01,6.93,4.85c2.31,3.7,3.69,6.24,4.16,7.62c0.92,3.7,1.38,6.7,1.38,9.01c0,2.32-0.46,5.31-1.38,9.01  c-1.85,3.7-3.24,6.24-4.16,7.62c-2.77,2.77-5.09,4.63-6.93,5.54c-2.77,1.39-5.78,2.08-9,2.08c-5.54,0-10.17-1.84-13.86-5.54  c-4.15-3.22-6.47-7.62-6.93-13.16h-24.94c0,6.01,1.38,11.55,4.15,16.63c2.77,5.09,6.24,9.25,10.4,12.48  c4.61,3.7,9.46,6.24,14.55,7.62c5.54,1.39,11.32,2.08,17.32,2.08c5.08,0.47,10.85-0.45,17.32-2.77c5.08-1.84,9.93-5.08,14.55-9.7  c4.16-3.23,7.63-7.85,10.4-13.86c2.31-6,3.46-12.01,3.46-18.02c0-5.54-0.69-11.09-2.08-16.63c-1.38-3.23-3.93-7.63-7.62-13.17  c-4.16-4.15-8.31-7.16-12.48-9c-4.63-2.31-9.94-3.47-15.94-3.47c-5.09,0-9.47,0.69-13.17,2.08c-3.24,1.39-6.93,3.93-11.09,7.62  l-0.69-0.69l5.54-27.72H214z M219.55,250h-13.17l-30.49,17.32L145.4,250h-13.86v75.53l36.73-36.73l1.38-1.38  c1.39-1.39,3.47-2.08,6.24-2.08c2.31,0,4.38,0.69,6.24,2.08v0.69l0.69,0.69l36.73,36.73v-49.89V250z"
              vectorEffect="non-scaling-stroke"
            />
          </g>
        </svg>
      );
      break;

    default:
      break;
  }

  if (iconSvg) {
    return (
      <span style={style as any} className={clsx("MedalIcon CustomIcon", className)}>
        {React.cloneElement(iconSvg, { className })}
      </span>
    );
  } else {
    return null;
  }
};

export default MedalIcon;
